import { ModalWindow } from "./modalWindow.js";

export class ModalSelectTimeFrame extends ModalWindow {

   constructor(title, callback) {
      super();

      this.panel.classList.add('dark-transparent');

      this.elMain = HTMLElement.createFromHTML(`
         <div class="modal-select-time-frame">
            <div class="container">
               <div class="title">${title}</div>
               <div class="buttons">
                  <button class="btn-regular button-round">Reguläre Stunden</button><br>
                  <button class="btn-short button-round">Kurzstunden</button>
               </div>
            </div>
         </div>
      `);

      this.panel.append(this.elMain);

      this.elMain.querySelector('.btn-regular').onclick = () => {
         callback('regular');
         this.close();
      };

      this.elMain.querySelector('.btn-short').onclick = () => {
         callback('short');
         this.close();
      };

      setTimeout(() => this.show(), 1);

   }
}
